import { createRoot } from "react-dom/client";
// Block known external proxy/injection hosts early
import "./lib/block-proxy";
import "./lib/runtimeErrorLogger";
import { initErrorLogger } from "./lib/errorLogger";
import "./index.css";

// Initialize error logging to Firebase
initErrorLogger();

// Clear the disableFirestore flag so Firestore works
if (typeof window !== 'undefined') {
	window.localStorage.removeItem('disableFirestore');
}

function showFatalError(err: unknown) {
	const rootEl = document.getElementById('root');
	if (!rootEl) return;

	const message =
		err && typeof err === 'object' && 'message' in err
			? String((err as { message?: unknown }).message)
			: String(err);
	const stack =
		err && typeof err === 'object' && 'stack' in err
			? String((err as { stack?: unknown }).stack ?? '')
			: '';

	rootEl.innerHTML = `
		<div style="padding:16px; font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;">
			<h1 style="font-size:18px; font-weight:700; margin:0 0 8px;">App error</h1>
			<p style="margin:0 0 12px; opacity:0.9;">A runtime error prevented the app from loading.</p>
			<pre style="white-space:pre-wrap; word-break:break-word; padding:12px; border:1px solid rgba(255,255,255,0.15); border-radius:8px; background:rgba(0,0,0,0.25); overflow:auto;">${escapeHtml(
				message + (stack ? `\n\n${stack}` : '')
			)}</pre>
			<p style="margin:12px 0 0; opacity:0.85;">If you can, screenshot this and send it back.</p>
		</div>
	`;
}

function escapeHtml(input: string) {
	return input
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#039;');
}

// Ensure we never silently white-screen.
window.addEventListener('error', (event) => {
	showFatalError(event.error ?? event.message);
});
window.addEventListener('unhandledrejection', (event) => {
	showFatalError((event as PromiseRejectionEvent).reason);
});

import App from './App.tsx';

const root = createRoot(document.getElementById("root")!);

try {
	root.render(<App />);
} catch (err) {
	showFatalError(err);
}
